<template>
  <pbc-overlay ref='modal' @close="close" @done='done' :disable-title="true">
    <template #default="{}">
      <instant-add-pack :partutil='partutil'
                            :render-tools='renderTools'
                            :grid='true'
                            :selected-layers='selectedLayers'
                            :layers='layers'
                            :holder-data='holderData'
                            @hide-for-placing='onHideForPlacing'
                            @mode='onMode'
                            @add-children='onAddChildren'
                            @transform-update='onTransformUpdate' 
                            @select-children='onSelectChildren'
                            />
    </template>

  </pbc-overlay>

</template>
<script>
import Close from '@icons/Close.vue';
import InstantAddPack from '@ui/organisms/InstantAddPack.vue';
export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    selectedLayers: {
      type: Object,
      required: true
    },
    layers: {
      type: Object,
      required: true
    }

  },
  data() {
    return {
      instantMode: 'choosepack'
    }
  },
  components: {
    InstantAddPack,
    //Close
  },
  methods: {
    done() {
      this.$emit('done');
      this.$ana.track({
        eventCategory:'ui',
        eventAction:'doneSimpleOrAdvanced'
      });
    },
    close() {
      this.$emit('close');
      this.$ana.track({
        eventCategory:'ui',
        eventAction:'cancelSimpleOrAdvanced'
      });
    },
    onAdvanced() {
      this.$emit('advanced-mode');
    },
    onHideForPlacing() {
      console.log('am hide for placing');
      this.$emit('hide-for-placing');
    },
    onMode(data) {
      this.instantMode = data;
      this.$emit('mode', data);
    },
    onAddChildren(data) {
      this.$emit('add-children', data);
      this.$emit('done');
    },
    onTransformUpdate(data) {
      this.$emit('transform-update', data);
      this.$emit('done');
    },
    onSelectChildren(data) {
      console.log('onSelectChildren', data);
      this.$emit('select-children', data);
      this.$emit('done');
    }
  },
  computed: {
    cta() {
      if (this.instantMode === 'choosepack') {
        return 'Choose a Pack'
      } else if (this.instantMode === 'chosepack') {
        return 'Choose a Toy'
      }
      return '';
    }
  }
}
</script>
